import { render, staticRenderFns } from "./ShippingPriceCollapse.vue?vue&type=template&id=229b5d84"
import script from "./ShippingPriceCollapse.vue?vue&type=script&lang=ts"
export * from "./ShippingPriceCollapse.vue?vue&type=script&lang=ts"
import style0 from "./ShippingPriceCollapse.vue?vue&type=style&index=0&id=229b5d84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports